import React, { useEffect } from "react";
import { Modal, Form, Input, Col, Row, message } from "antd";
import { API_METHODS } from "../../../constants";
import useApi from "../../../hooks/useApi";

function AddSubject(props) {
  const [form] = Form.useForm();
  const { visible, close, selectedRecord } = props;

  const [response, request] = useApi("/admin/subject", null, API_METHODS.POST);
  const [editResponse, editRequest] = useApi(
    `/admin/subject/${selectedRecord && selectedRecord.id}`,
    null,
    API_METHODS.PUT
  );

  useEffect(() => {
    if (response.data) {
      close(true);
      message.success("Subject added successfully.");
    } else if (response.error) {
      close(true);
    }
  }, [response]);

  useEffect(() => {
    if (editResponse.data) {
      close(true);
      message.success("Subject updated successfully.");
    } else if (editResponse.error) {
      close(true);
    }
  }, [editResponse]);

  useEffect(() => {
    if (selectedRecord) {
      form.setFieldsValue(selectedRecord);
    }
  }, [selectedRecord]);

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        if (selectedRecord) {
          editRequest(values);
        } else {
          request(values, API_METHODS.POST);
        }
      })
      .catch((e) => { });
  };

  const handleCancel = () => {
    close();
  };

  return (
    <Modal
      title={selectedRecord ? "Update Subject" : "Add Subject"}
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      width={1000}
      okText="Save"
    >
      <Form layout="vertical" form={form}>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="subject_name"
              label="Subject Name"
              rules={[
                { required: true, message: "Subject Name is required." },
                {
                  max: 100,
                  message: "Subject Name should be maximum of 100 characters.",
                },
              ]}
            >
              <Input placeholder="Subject Name" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

export default AddSubject;
